import styled from 'styled-components';

import { Divider } from '@xing-com/divider';
import { GridContainer } from '@xing-com/grid';
import { mediaSmallOrTiny } from '@xing-com/layout-tokens';
import { SkeletonHeadline, SkeletonBody } from '@xing-com/skeleton';
import {
  scale000,
  space3XL,
  space4XL,
  space5XL,
  spaceL,
} from '@xing-com/tokens';

const GlossaryGridContainer = styled(GridContainer)`
  margin-bottom: ${space4XL};

  @media ${mediaSmallOrTiny} {
    margin-bottom: ${space3XL};
  }
`;

const GlossarySkeletonHeadline = styled(SkeletonHeadline)`
  margin-top: ${space5XL};

  @media ${mediaSmallOrTiny} {
    margin-top: ${space4XL};
  }

  & > div {
    margin-bottom: ${scale000};
  }
`;

const GlossarySkeletonBody = styled(SkeletonBody)`
  & > div:last-child {
    margin-bottom: ${scale000};
  }

  @media (min-width: 1113px) {
    & > div {
      margin-bottom: ${scale000};

      &:last-child {
        display: none;
      }
    }
  }
`;

const StyledSkeletonHeadline = styled(SkeletonHeadline)`
  & > div {
    margin-bottom: ${scale000};
  }
`;

const StyledDivider = styled(Divider)`
  margin-bottom: ${spaceL};
`;

const StyledSkeletonBody = styled(SkeletonBody)`
  & > div:last-child {
    margin-bottom: ${scale000};
  }
`;

const StyledGridContainer = styled(GridContainer)`
  margin-bottom: ${space5XL};

  @media ${mediaSmallOrTiny} {
    margin-bottom: ${space4XL};
  }
`;

export const Styled = {
  GlossaryGridContainer,
  GlossarySkeletonHeadline,
  GlossarySkeletonBody,
  SkeletonHeadline: StyledSkeletonHeadline,
  Divider: StyledDivider,
  SkeletonBody: StyledSkeletonBody,
  GridContainer: StyledGridContainer,
};
